// import ZoncuActivityDetail from '../activityOperateDetail'
import ZoncuActivity from './index.js';
import Microapp from '@/components/micro-app';
import React from 'react';
import env from '@/env';
import history from '@/history';
import { showUserVoice } from '@/components/userVoice';

// import ActivityGoods from './components/activityGoods/'
// import ActivityOperateChildren from './components/avenueOperate/route-config'
// import ActivityGoodsDetail from './components/activityGoodsDetail'

export default [
  {
    path: '/',
    component: ZoncuActivity,
    // menus: ActivityOperateChildren
    // getlog () {
    //   return 'jrhd_1603708380892|6'
    // }
  },
  {
    path: '/detail/*',
    component: () => (
      <Microapp
        // http://mcbeta.jd.com/dist/pages/activeManageBlock/page?activityId=10593419
        url={env.MC_DOMAIN + '/unitiedMarketing'}
        name="MyManageZongcuActivityDetail"
        data={{
          basename: '/activity-manage/myCreate/zongcuActivity/myManage/detail',
          flag: 'create',
          goBackHDCenter,
          showUserVoice,
        }}
      />
    ),
  },
  {
    path: '/create/*',
    component: () => (
      <Microapp
        // http://mcbeta.jd.com/dist/pages/activeManageBlock/page?activityId=10593419
        url={env.MC_DOMAIN + '/unitiedMarketing'}
        name="MyManageZongcuActivityCreate"
        data={{
          basename: '/activity-manage/myCreate/zongcuActivity/myManage/create',
          flag: 'create',
          goBackHDCenter,
          showUserVoice,
        }}
        // onDataChange={(e) => createSuccess(e.detail.data)}
      />
    ),
  },
];

function goBackHDCenter() {
  history.replace('/activity-manage/myCreate/zongcuActivity/myManage');
}
